import { render, staticRenderFns } from "./projectReviewScore.vue?vue&type=template&id=23211b6e&scoped=true&"
import script from "./projectReviewScore.vue?vue&type=script&lang=js&"
export * from "./projectReviewScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23211b6e",
  null
  
)

export default component.exports